import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CustomModal = ({ show, handleClose, title, bodyText, negativebtnvalue, positivebtnvalue, modalBtnStatus}) => {
    
    const handleButtonClick = (isPositiveAction) => {
        if (isPositiveAction) {
            // Action for positive button
           modalBtnStatus(isPositiveAction)
        } else {
            // Action for negative button
           modalBtnStatus(isPositiveAction)
        }
        handleClose(); // Close modal after action
    };

    return (
        <Modal show={show} onHide={handleClose} >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">{bodyText}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => handleButtonClick(false)}
                    style={{ borderColor: 'green', color: 'green', width: '47%' }}
                >
                    {negativebtnvalue}
                </Button>
                <Button
                    variant="success"
                    onClick={() => handleButtonClick(true)}
                    style={{ backgroundColor: 'green', borderColor: 'green', width: '47%' }}
                >
                    {positivebtnvalue}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomModal;
